import axios from "axios";
import { Earth, Loader, NotepadText, Pin } from "lucide-react";
import React, { useState } from "react";
import getToken from "../../../../../hooks/getToken";
import { useNavigate, useParams } from "react-router-dom";
import { useUserSelection } from "../../../../../store/UserPayment";
import Swal from "sweetalert2";
import Riyal from "../../../../ui/riyal";
import { useLanguage } from "../../../../../store/language-context";
import { useTranslation } from "react-i18next";
import TrCourseImg from "../../../../../assets/images/TrainingCoursesImg.png";

const OfferBox = ({ offer }) => {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const { setRowDetails } = useUserSelection();
    const { price_before_discount, price, course, category, city ,start_date, end_date} = offer;

    const navigate = useNavigate();
    const token = getToken();
    const { id } = useParams();

    const [response, setResponse] = useState({
        loading: false,
        message: '',
        error: null,
    });

    const registerInOffer = async () => {
      
        if (!token) {
            Swal.fire({
                icon: 'warning',
                title: t('custom.login-first'),
                text: t(''),
                confirmButtonText: t('custom.accept'),
            }).then((result) => {
                if (result.isConfirmed) {
                    
                    navigate('/login');
                }
            });
            return;
        }

    
        setResponse(prev => ({ ...prev, loading: true }));
        try {
            const res = await axios.post(`${URL}/offer-register`, {
                offer_id: id
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (res.status === 201) {
                // Upload the price and details after successful registration
                setRowDetails(prev => ({
                    ...prev,
                    courseId: offer?.course?.id,
                    courseOfferId: offer?.id,
                    courseOfferPrice: offer?.price,
                    thisRowPrice: offer?.price_before_discount,
                    discount: offer?.discount,
                }));
                navigate(`/offers/${id}/payment/way`);
            }
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: t('custom.failed'),
                text: t('custom.registration-failed'),
                confirmButtonText: t('custom.accept')
            });
        } finally {
            setResponse(prev => ({ ...prev, loading: false }));
        }
    };

    return (
        <div className='relative group pt-7 pb-3 px-3 grid max-lg:grid-cols-1 lg:grid-cols-[22%_77%] border rounded-lg w-full mb-5 mt-5'>
        <div className='relative w-32 bg-transparent max-lg:h-18'>
            <div className='w-[7.5rem] h-[7.5rem] flex justify-center items-center absolute -top-14 inset-y-0 end-16 max-lg:end-5 max-lg:h-28 max-lg:w-48 max-lg:relative'>
                <div className='bg-secondary-tw w-[7.8rem] h-[7.8rem] max-lg:h-[7.4rem] max-lg:w-[12.4rem] absolute z-0 rounded-lg'></div>
                <img src={course?.image || TrCourseImg} alt='course-title' className='object-cover w-full relative z-10 h-full rounded-lg' />
                <div className="absolute -bottom-8 z-20 bg-secondary-tw rounded-md text-white px-2">
                    <p className="m-0">{offer?.discount}%</p>
                    <p className="m-0">{t('training-courses.discount')}</p>
                </div>
            </div>
        </div>
        <div className='flex flex-col justify-between gap-4 max-lg:mt-24'>
            <div className='text-start space-y-1'>
                {course?.title &&

                    <p className='text-primary-tw text-xl truncate !text-start max-w-96'>
                        {course?.title}
                    </p>
                }
                {
                    category?.title &&
                    <div className='flex items-center gap-2'>
                        <span>
                            <Pin fill='#7A7A7A' size={16} color='#7A7A7A' />
                        </span>
                        <p className='text-semi-gray text-sm truncate m-0'>
                            {category?.title}
                        </p>
                    </div>
                }
                {
                    course?.title &&
                    <div className='flex items-center gap-2'>
                        <span>
                            <NotepadText fill='white' size={16} color='#7A7A7A' />
                        </span>
                        <p className='text-semi-gray text-sm truncate m-0'>
                            {course?.title}
                        </p>
                    </div>
                }
                {
                    city?.title &&
                    <div className='flex items-center gap-2'>
                        <span>
                            <Earth size={16} color='#7A7A7A' />
                        </span>
                        <p className='text-semi-gray text-sm truncate m-0'>
                            {city?.title}
                        </p>
                    </div>
                }
                <div className='flex items-center gap-2'>
                    {/* <span>
                        <Calendar size={16} color='#7A7A7A' />
                    </span> */}
                    <div className='text-semi-gray text-sm'>
                        {start_date} <span className="mx-1">الى</span> {end_date}
                    </div>
                </div>
            </div>
            <div className='flex items-center gap-2 mt-2 flex-wrap max-lg:items-start'>
                <p className='text-semi-gray text-sm'>
                    {t('profile.price')} :
                </p>
                <p className=' bg-primary-tw text-sm flex items-center gap-1 text-white px-3 rounded-md py-[1px]'>
                    <span>
                        {price || "0"} {t('custom.instead')} <del>{price_before_discount || "0"}</del>
                    </span>
                    <span>
                        <Riyal />
                    </span>
                </p>
            </div>
        </div>
        <div className="flex items-center justify-end gap-2 mt-3 w-full col-span-2">
            <button className=" bg-secondary-tw text-white px-4 py-1 rounded-lg"
                onClick={registerInOffer}
            >
                {response.loading ?
                    <div className="flex items-center gap-2 h-fit">
                        <Loader className=" animate-spin size-4" />
                        <p className="m-0">{t('custom.checking')}</p>
                    </div>
                    :
                    t('custom.check')
                }
            </button>

        </div>
    </div>
    );
};

export default React.memo(OfferBox);
